/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/configurator/ToolbarButton.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-row flex-nowrap"
};
const _hoisted_2 = {
  class: "flex items-center flex-nowrap px-2 border-gray-500 border-r-[0.5px] border-opacity-40"
};
const _hoisted_3 = {
  class: "flex flex-nowrap justify-start items-center px-2 border-gray-500 border-r-[0.5px] border-opacity-40"
};
const _hoisted_4 = {
  class: "flex flex-nowrap items-center px-2 border-gray-500 border-r-[0.5px] border-opacity-40"
};
const _hoisted_5 = {
  class: "flex flex-nowrap items-center ms-2"
};
import { useConfigurationStore } from '@/stores/configurationModule';
export default {
  __name: 'MainObjectEditor',
  setup(__props) {
    const configurationStore = useConfigurationStore();
    const {
      activeObjects
    } = storeToRefs(configurationStore);
    const $eventBus = inject('bus');
    const multipleObjectsSelected = computed(() => {
      return activeObjects.value.length > 1;
    });

    // @TODO: organize these functions alphabetically
    function handelCenterHorizontal() {
      $eventBus.$emit("center-selection-h");
    }
    function handelCenterVertical() {
      $eventBus.$emit("center-selection-v");
    }
    function handleBringForward() {
      $eventBus.$emit("move-forward");
    }
    function handleBringBackward() {
      $eventBus.$emit("move-backward");
    }
    function handelRemove() {
      $eventBus.$emit("objects-removed");
    }
    function handleBringToFront() {
      $eventBus.$emit("bring-to-front");
    }
    function handleSendToBack() {
      $eventBus.$emit("move-to-back");
    }
    function onClickHandleObjectRotateClockwise() {
      $eventBus.$emit('object-rotated');
    }
    function handleDuplicate() {
      $eventBus.$emit('object-duplicated');
    }
    function handleAlignLeft() {
      $eventBus.$emit('align-left-selection-h');
    }
    function handleAlignRight() {
      $eventBus.$emit('align-right-selection-h');
    }
    function handleAlignTop() {
      $eventBus.$emit('align-top-selection-v');
    }
    function handleAlignBottom() {
      $eventBus.$emit('align-bottom-selection-v');
    }
    return (_ctx, _cache) => {
      const _component_ToolbarButton = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ToolbarButton, {
        icon: "align-v-start",
        tooltip: "Align Top",
        onClick: handleAlignTop
      }), _createVNode(_component_ToolbarButton, {
        icon: "align-v-center",
        tooltip: "Align Center Vertically",
        onClick: handelCenterVertical
      }), _createVNode(_component_ToolbarButton, {
        icon: "align-v-end",
        tooltip: "Align Bottom",
        onClick: handleAlignBottom
      }), _createVNode(_component_ToolbarButton, {
        icon: "align-h-start",
        tooltip: "Align Left",
        onClick: handleAlignLeft
      }), _createVNode(_component_ToolbarButton, {
        icon: "align-h-center",
        tooltip: "Align Center Horizontally",
        onClick: handelCenterHorizontal
      }), _createVNode(_component_ToolbarButton, {
        icon: "align-h-end",
        tooltip: "Align Right",
        onClick: handleAlignRight
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_ToolbarButton, {
        icon: "arrange-forward",
        tooltip: "Bring Forward",
        onClick: handleBringForward
      }), _createVNode(_component_ToolbarButton, {
        icon: "arrange-front",
        tooltip: "Bring to Front",
        onClick: handleBringToFront
      }), _createVNode(_component_ToolbarButton, {
        icon: "arrange-backward",
        tooltip: "Send Backward",
        onClick: handleBringBackward
      }), _createVNode(_component_ToolbarButton, {
        icon: "arrange-back",
        tooltip: "Send to Back",
        onClick: handleSendToBack
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_ToolbarButton, {
        icon: "rotate-clockwise",
        tooltip: "Rotate by 90°",
        onClick: onClickHandleObjectRotateClockwise
      }), _createVNode(_component_ToolbarButton, {
        icon: "duplicate",
        tooltip: "Duplicate",
        disabled: _unref(multipleObjectsSelected),
        onClick: handleDuplicate
      }, null, 8, ["disabled"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_ToolbarButton, {
        icon: "trash",
        tooltip: "Remove",
        onClick: handelRemove
      })])]);
    };
  }
};